import { connect } from 'react-redux'
import { actions } from '../../store/resourceLinks'

function mapStateToProps(state) {
  return {
    // ── Government Resources ─────────────────────
    governmentResources: state.resourceLinks.governmentResources || [],
    governmentResourceDetail: state.resourceLinks.governmentResourceDetail,

    // ── Federal Agency Links ────────────────────
    agencyLinks: state.resourceLinks.agencyLinks || []
  }
}

function mapDispatchToProps(dispatch) {
  return {
    // ── Government Resources ─────────────────────
    getGovernmentResourcesList: params =>
      dispatch(actions.getGovernmentResourcesList(params)),
    getGovernmentResource: params =>
      dispatch(actions.getGovernmentResource(params)),
    createGovernmentResource: params =>
      dispatch(actions.createGovernmentResource(params)),
    updateGovernmentResource: params =>
      dispatch(actions.updateGovernmentResource(params)),
    deleteGovernmentResource: params =>
      dispatch(actions.deleteGovernmentResource(params)),

    // ── Federal Agency Links ────────────────────
    getAgencyLinksList: () =>
      dispatch(actions.getAgencyLinksList()),
    updateAgencyLink: params =>
      dispatch(actions.updateAgencyLink(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
